import { FC, useContext } from "react";
import appStyles from "../../../App.module.css";
import ForwardArrow from "../../../amt/components/icons/ForwardArrow";
import { formatAmount } from "../../../app-constants";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortuguesePurchasePathContext } from "../../config/interface";
interface NextButtonProps {
  title: string;
  onClick?: () => void;
  type?: string;
  disable?: boolean;
}

const NextButton: FC<NextButtonProps> = (props: NextButtonProps) => {
  const { quoteData, quoteResult } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;
  const { title, onClick, type = "button", disable } = props;
  return (
    <button
      className={`${appStyles.bfButton} ${appStyles.bfbuttonHasIcon} ${appStyles.bfButtonSecondary} ${appStyles.bfbuttonIconAfter}`}
      type={type === "submit" ? "submit" : "button"}
      onClick={onClick}
      disabled={disable}
    >
      {title}&nbsp;
      {title !== "Get Quote" &&
        title !== "Processing.." &&
        `${formatAmount(quoteResult?.quoted_price || 0, "US", quoteData.currency?.value || "EUR")}`}
      <span className={`${appStyles.bfButtonIcon}`}>
        <ForwardArrow />
      </span>
    </button>
  );
};

export default NextButton;
